import React from 'react';
import { Star } from 'lucide-react';
interface Review {
  name: string;
  location: string;
  text: string;
  rating?: number;
}
const italianReviews: Review[] = [{
  name: 'Giovanni',
  location: 'Milano',
  text: 'Finalmente un manuale che unisce tecnica e prevenzione. Ho smesso di avere dolori al gomito dopo ogni partita. Consigliatissimo!',
  rating: 5
}, {
  name: 'Alessandro',
  location: 'Roma',
  text: 'Ho migliorato la mia bandeja in due settimane grazie ai consigli tecnici. Le spiegazioni sono chiare e subito applicabili in campo.',
  rating: 5
}, {
  name: 'Chiara',
  location: 'Torino',
  text: "Ottimo per chi vuole fare il salto di qualità senza farsi male. I bonus sono un'aggiunta fantastica, specialmente il planner.",
  rating: 5
}];
const argentinianReviews: Review[] = [{
  name: 'Matteo',
  location: 'Verona',
  text: 'Incredibile! Ho risolto il mio problema al gomito e ora gioco molto meglio. La sezione tattica è oro puro.',
  rating: 5
}, {
  name: 'Luca',
  location: 'Genova',
  text: 'Le tattiche di coppia hanno cambiato il modo in cui giochiamo io e il mio compagno. Ora vinciamo partite che prima perdevamo.',
  rating: 5
}, {
  name: 'Martina',
  location: 'Firenze',
  text: 'I bonus sono fantastici, specialmente il planner di allenamento settimanale. Mi ha aiutato a strutturare la mia routine.',
  rating: 5
}, {
  name: 'Davide',
  location: 'Bari',
  text: 'Un manuale completo. La sezione sulla prevenzione degli infortuni vale da sola il prezzo. Lo porto sempre con me sul telefono.',
  rating: 5
}, {
  name: 'Valentina',
  location: 'Bologna',
  text: 'Molto chiaro e pratico. Lo consiglio a tutti i giocatori amatoriali che vogliono prendere il padel sul serio.',
  rating: 5
}];
function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100 flex flex-col gap-3" data-id="element-170">
      <div className="flex gap-1" data-id="element-171">
        {[...Array(review.rating || 5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-172" />)}
      </div>
      <p className="text-gray-700 italic text-sm md:text-base" data-id="element-173">
        "{review.text}"
      </p>
      <div className="mt-auto pt-3 border-t border-gray-50 flex items-center gap-3" data-id="element-174">
        <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold" data-id="element-175">
          {review.name.charAt(0)}
        </div>
        <div data-id="element-176">
          <p className="font-bold text-gray-900 text-sm" data-id="element-177">{review.name}</p>
          <p className="text-xs text-gray-500" data-id="element-178">{review.location}</p>
        </div>
      </div>
    </div>;
}
export function ItalianTestimonials() {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-8" data-id="element-179">
      {italianReviews.map((review, i) => <ReviewCard key={i} review={review} data-id="element-180" />)}
    </div>;
}
export function ArgentinianTestimonials() {
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-8" data-id="element-181">
      {argentinianReviews.map((review, i) => <ReviewCard key={i} review={review} data-id="element-182" />)}
    </div>;
}